import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import env from 'Env';
import imgixConfig from 'Config/imgix';
import ProductCover from 'Components/Utility/ProductCover';

import 'Components/Banner/NonGameBanner.scss';

export default function NonGameBanner() {
  const startDate = '2022-09-09T09:00:00.000Z';
  const endDate = '2022-09-19T06:00:00.000Z';
  if (Date.now() < Date.parse(startDate) || Date.now() > Date.parse(endDate)) return false;

  const bgImgSrc = `${env.cdnUrl}/assets/banners/non-game/day-of-the-programmer-2022/idotp-character.png`;

  return (
    <div className="container homepage-section-margin">
      <Link to="/bundle/international-day-of-the-programmer-free-giveaway">
        <div className="NonGameBanner">
          <div className="NonGameBanner__coverContainer">
            <ProductCover
              cover="non-game/day-of-the-programmer-2022/idotp-cover.jpg"
              folder="assets/banners"
              alt="World Music Day 2022 Free Giveaway"
            />
          </div>
          <div className="NonGameBanner__detailsContainer">
            <div className="NonGameBanner__mainText">
              <FormattedMessage id="non-game-banner.title" defaultMessage="Get a Free Dev eBook Bundle" />
            </div>
            <div className="NonGameBanner__subText">
              <FormattedMessage id="non-game-banner.subtitle" defaultMessage="To celebrate International Day of the Programmer" />
            </div>
            <div className="NonGameBanner__buttonContainer">
              <div className="NonGameBanner__button">
                <FormattedMessage id="non-game-banner.button" defaultMessage="Plus save 20% on selected others" />
              </div>
            </div>
          </div>

          <div className="NonGameBanner__background">
            <img
              srcSet={`
                ${bgImgSrc}?${imgixConfig}&w=746&h=459&fit=crop,
                ${bgImgSrc}?${imgixConfig}&w=500&h=308&fit=crop,
                ${bgImgSrc}?${imgixConfig}&w=373&h=230&fit=crop
              `}
              src={`${bgImgSrc}?${imgixConfig}&w=746&h=459&fit=crop`}
              alt="International Day of the Programmer"
            />
          </div>
        </div>
      </Link>
    </div>
  );
}
